import React from "react";
import {
	primaryColor,
	primaryTextColor,
	fw400,
	titleM,
} from "./../../../Global.module.css";
import styles from "./MenuItem.module.css";

export default function MenuItem({ text, active }) {
	const menuItemClass = `${primaryTextColor} ${titleM} ${fw400} ${styles.menuItem}`;
	const menuItemActiveClass = `${primaryColor} ${titleM} ${fw400} ${styles.menuItem}`;
	return (
		<p className={active ? menuItemActiveClass : menuItemClass}>{text}</p>
	);
}
